import {isEmpty, template} from 'lodash';
import axios from 'axios';
import {buildHttpRequestHeader, buildHttpUrl} from '@app/utils';

export const rqCreateMultipartRequest = (api, body, token, params, signal) => {
  return rqCreateRequest(
    api,
    body,
    token,
    params,
    signal,
    'multipart/form-data',
  );
};

export const rqCreateRequest = (
  api,
  body,
  token,
  params,
  signal,
  contentType = 'application/json',
  accept = 'application/json',
  filter = {},
) => {
  console.log(api, params);
  let url = api.url;
  if (params !== null && params !== undefined) {
    url = template(url)(params);
  }

  if (isEmpty(token)) {
    token = '';
  }

  const headers = buildHttpRequestHeader({}, api.auth, token, contentType);

  if (api.search) {
    url = `${url}${new URLSearchParams(filter).toString()}`;
  }

  if (api.method === 'POST') {
    return axios
      .post(buildHttpUrl(url), body, {
        headers: headers,
        signal,
      })
      .then(response => response.data);
  } else if (api.method === 'PUT') {
    return axios
      .put(buildHttpUrl(url), body, {
        headers: headers,
        signal,
      })
      .then(response => response.data);
  } else {
    return axios({
      url: buildHttpUrl(url),
      method: api.method,
      headers: headers,
      signal,
    }).then(response => response.data);
  }
};

export const rqCreateSearchRequest = (
  api,
  body,
  certificate,
  params,
  signal,
  filter = {},
  contentType = 'application/json',
  accept = 'application/json',
) => rqCreateRequest(
  api,
  body,
  certificate,
  params,
  signal,
  contentType,
  accept,
  filter,
);
